"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function RequestTechnicalQuote() {
  const {
    ref: rootRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const baseTransition = "transition-all duration-[1200ms] ease-out";
  const hidden = "opacity-0 translate-y-4";
  const shown = "opacity-100 translate-y-0";
  return <section data-section-id="1617" id="request-technical-quote" className="relative bg-background text-foreground py-40 md:py-56 px-6 md:px-12 overflow-hidden">
      {}
      <div className="absolute top-0 left-0 right-0 flex items-center pointer-events-none">
        <span className="w-1 h-1 bg-primary shrink-0" aria-hidden="true" />
        <span className="flex-1 h-px bg-primary" aria-hidden="true" />
        <span className="w-1 h-1 bg-primary shrink-0" aria-hidden="true" />
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 flex items-center pointer-events-none">
        <span className="w-1 h-1 bg-primary shrink-0" aria-hidden="true" />
        <span className="flex-1 h-px bg-primary" aria-hidden="true" />
        <span className="w-1 h-1 bg-primary shrink-0" aria-hidden="true" />
      </div>

      <div ref={rootRef} className="max-w-3xl mx-auto flex flex-col items-center text-center">
        {}
        <p data-index={0} className={`font-mono text-xs md:text-[0.8125rem] uppercase text-muted-foreground ${baseTransition} ${isVisible ? shown : hidden}`} style={{
        letterSpacing: "0.18em",
        transitionDelay: "0ms"
      }}>
          § 01 — PROJECT INTAKE · SPECIFICATION REVIEW
        </p>

        {}
        <div className={`mt-12 ${baseTransition} ${isVisible ? shown : hidden}`} style={{
        transitionDelay: "520ms"
      }} aria-hidden="true">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-primary">
            <circle cx="24" cy="24" r="22" stroke="currentColor" strokeWidth="1.25" />
            <circle cx="24" cy="24" r="12" stroke="currentColor" strokeWidth="1.25" />
            <circle cx="24" cy="24" r="3.5" fill="currentColor" />
          </svg>
        </div>

        {}
        <h2 className={`mt-10 font-default font-bold text-foreground ${baseTransition} ${isVisible ? shown : hidden}`} style={{
        fontSize: "clamp(2.5rem, 5.5vw, 5rem)",
        letterSpacing: "-0.025em",
        lineHeight: "1.0",
        transitionDelay: "240ms"
      }}>
          Permanent. Compliant. <em className="italic text-primary">Specified</em>
          <br />
          by name.
        </h2>

        {}
        <p className={`mt-10 font-default font-normal text-foreground/90 ${baseTransition} ${isVisible ? shown : hidden}`} style={{
        fontSize: "clamp(1.125rem, 1.6vw, 1.5rem)",
        lineHeight: "1.55",
        maxWidth: "50ch",
        transitionDelay: "360ms"
      }}>
          Send us your file, spec, or part list. We handle the engraving, documentation, and shipping. No fluff, just precision.
        </p>

        {}
        <div className={`mt-12 flex items-center ${baseTransition} ${isVisible ? shown : hidden}`} style={{
        width: "120px",
        transitionDelay: "480ms"
      }} aria-hidden="true">
          <span className="w-1 h-1 bg-primary shrink-0" />
          <span className="flex-1 h-px bg-primary" />
          <span className="w-1 h-1 bg-primary shrink-0" />
        </div>

        {}
        <div className={`mt-12 w-full sm:w-auto px-6 sm:px-0 ${baseTransition} ${isVisible ? shown : hidden}`} style={{
        transitionDelay: "600ms"
      }}>
          <Button asChild className="group relative w-full sm:w-auto bg-accent text-accent-foreground hover:bg-accent/90 font-default font-semibold uppercase px-9 py-6 h-auto text-sm transition-colors duration-300" style={{
          letterSpacing: "0.14em"
        }}>
            <Link to="/ContactPage">
              <span className="relative inline-flex items-center">
                Request a Quote
                <span aria-hidden="true" className="hidden sm:inline-flex absolute left-full top-1/2 -translate-y-1/2 ml-2 items-center overflow-hidden transition-all duration-300 ease-out w-0 group-hover:w-6">
                  <span className="h-px bg-primary w-full" />
                  <span className="w-1 h-1 bg-primary shrink-0" />
                </span>
              </span>
            </Link>
          </Button>
        </div>

        {}
        <div className={`mt-8 ${baseTransition} ${isVisible ? shown : hidden}`} style={{
        transitionDelay: "720ms"
      }}>
          
        </div>

        {}
        <p className={`mt-24 font-mono text-xs text-muted-foreground ${baseTransition} ${isVisible ? shown : hidden}`} style={{
        letterSpacing: "0.12em",
        transitionDelay: "840ms"
      }}>
          US-BASED · VETERAN-OWNED · INDUSTRIAL MARKING
        </p>
      </div>
    </section>;
}